module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/flash-black-phone.7b4d983f.mp4";